import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';



// WEBPACK FOOTER //
// ./src/app/core/rxjs-extensions.ts